__turbopack_context__.v({
  "button": "style-module-scss-module__bL3HUW__button",
});
